import { me } from "constants/Client";
import moment from "moment-timezone/builds/moment-timezone-with-data-1970-2030";
import mt from "moment";
import { isEmpty } from "lodash";
import { dateFormat, fullDateFormat, namedMonthDateTime } from "constants/TaskConstants";

export const localCalendarFormat = (
  time,
  format = {
    sameDay: "[Today at] LT",
    nextDay: "[Tomorrow at] LT",
    nextWeek: namedMonthDateTime,
    lastDay: "[Yesterday at] LT",
    lastWeek: namedMonthDateTime,
    sameElse: namedMonthDateTime,
  }
) => {
  return mt().calendar(null, format);
};

export const utcToTimeZone = (time, format, checkZone = true) => {
  if (!time) return "";
  if (checkZone) {
    return moment
      .utc(time, "YYYY-MM-DD HH:mm:ss")
      .tz(me()?.time_zone || "Australia/Sydney")
      .format(format || "YYYY-MM-DD HH:mm:ss");
  } else {
    return mt(mt.utc(time).toDate(), "YYYY-MM-DD HH:mm:ss")
      .local()
      .format(format || "YYYY-MM-DD HH:mm:ss");
  }
};

export const utcToCalendarTimezone = (
  time,
  format = {
    sameDay: "[Today at] LT",
    nextDay: "[Tomorrow at] LT",
    nextWeek: namedMonthDateTime,
    lastDay: "[Yesterday at] LT",
    lastWeek: namedMonthDateTime,
    sameElse: namedMonthDateTime,
  },
  checkZone = true
) => {
  if (checkZone) {
    return moment
      .utc(time, "YYYY-MM-DD HH:mm:ss")
      .tz(me()?.time_zone || "Australia/Sydney")
      .calendar(null, format);
  } else {
    return mt(mt.utc(time, "YYYY-MM-DD HH:mm:ss").toDate()).calendar(null, format);
  }
};

export const utcToShortDates = time => {
  return moment
    .utc(time, "YYYY-MM-DD HH:mm:ss")
    .tz(me()?.time_zone || "Australia/Sydney")
    .calendar(null, {
      sameDay: "LT",
      nextDay: "MMM DD",
      nextWeek: "MMM DD",
      lastDay: "MMM DD",
      lastWeek: "MMM DD",
      sameElse: "MMM DD",
    });
};

export const localTimeOfTimezone = (format, checkZone = true, returnMoment = false) => {
  if (checkZone) {
    const time = moment().tz(me()?.time_zone || "Australia/Sydney");

    if (returnMoment) return time;

    return time.format(format || "YYYY-MM-DD HH:mm:ss");
  } else {
    return mt()
      .local()
      .format(format || "YYYY-MM-DD HH:mm:ss");
  }
};

export const givenTimeToUtc = (time, format, checkZone = true) => {
  if (isEmpty(time)) return "";
  if (checkZone) {
    return moment
      .tz(time, "YYYY-MM-DD HH:mm:ss", me()?.time_zone || "Australia/Sydney")
      .utc()
      .format(format || "YYYY-MM-DD HH:mm:ss");
  } else {
    return mt(time, "YYYY-MM-DD HH:mm:ss")
      .utc()
      .format(format || "YYYY-MM-DD HH:mm:ss");
  }
};

export const localTimeToUtc = (format, checkZone = true, isMoment = false) => {
  if (isMoment) {
    return moment.tz(me()?.time_zone || "Australia/Sydney").utc();
  } else if (checkZone) {
    return moment
      .tz(me()?.time_zone || "Australia/Sydney")
      .utc()
      .format(format || "YYYY-MM-DD HH:mm:ss");
  } else {
    return mt()
      .utc()
      .format(format || "YYYY-MM-DD HH:mm:ss");
  }
};

export const parseDate = (date, format = dateFormat, givenFormat = fullDateFormat) => {
  return mt(date, givenFormat).format(format);
};
